<div class="filter-chips-container">
  <div class="content">
    <span class="filter-headline">{{ 'filter.headline' | translate }}</span>
    <ng-container *ngFor="let chip of filterChips">
      <kion-filter-chip-list-item
        [chip]="chip"
        (selected)="chipSelected($event)"
      ></kion-filter-chip-list-item>
    </ng-container>
  </div>
</div>
